import CheckboxSelectAll from "@stimulus-components/checkbox-select-all";

export default class extends CheckboxSelectAll {
  static targets = [
    ...CheckboxSelectAll.targets,
    "count",
    "actions",
    "regenerateForm",
    "destroyForm",
  ];

  toggle(event) {
    super.toggle(event);
    this.#syncState();
  }

  refresh() {
    super.refresh();
    this.#syncState();
  }

  submitRegenerate() {
    this.#populateAndSubmit(this.regenerateFormTarget);
  }

  submitDestroy() {
    this.#populateAndSubmit(this.destroyFormTarget);
  }

  #populateAndSubmit(form) {
    const ids = this.checked.map((cb) => cb.value);
    if (ids.length === 0) return;

    this.#disableActions();

    // Clear previous hidden inputs
    form
      .querySelectorAll("input[name='version_ids[]']")
      .forEach((el) => el.remove());

    // Populate version_ids[]
    ids.forEach((id) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "version_ids[]";
      input.value = id;
      form.appendChild(input);
    });

    form.requestSubmit();
  }

  #disableActions() {
    if (this.hasActionsTarget) {
      this.actionsTarget.querySelectorAll("wa-button").forEach((btn) => {
        btn.disabled = true;
      });
    }
  }

  #syncState() {
    const count = this.checked.length;

    if (this.hasCountTarget) {
      this.countTarget.textContent = `${count} selected`;
    }

    if (this.hasActionsTarget) {
      this.actionsTarget.querySelectorAll("wa-button").forEach((btn) => {
        btn.disabled = count === 0;
      });
    }

    this.checkboxTargets.forEach((cb) => {
      cb.closest('[data-testid="activity-log-item"]')?.classList.toggle(
        "bulk-selected",
        cb.checked,
      );
    });
  }
}
